<app-poke-header></app-poke-header>

<main>
  <app-poke-list></app-poke-list>
</main>
